import { Outlet, useLocation } from "react-router-dom";

import TopBar from "components/layout/navbar/TopBar";
import { MissionOverviewRangeProvider } from "providers/MissionOverviewRangeProvider";

const DashboardLayout = ({ title, tabs }) => {
    const location = useLocation();
    const isMissionLogRoute =
        location.pathname.includes("/log/") && location.pathname.includes("mission");
    const pageTitle = location.pathname.endsWith("/missions")
        ? "Missions"
        : location.pathname.endsWith("/schedules")
        ? "Schedules"
        : isMissionLogRoute
        ? "Mission Log"
        : title;

    return (
        <div className="layout pl-20">
            <TopBar title={pageTitle} navigationItems={tabs} />
            <MissionOverviewRangeProvider>
                <Outlet context={[title]} />
            </MissionOverviewRangeProvider>
        </div>
    );
};

export default DashboardLayout;
